import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Ortak "boş durum" göstergesi (Faz 8 UI primitifi).
 * De-facto desenden: büyük soluk ikon + mesaj. Hem tablo içinde (TableCell colSpan ile
 * sarılarak) hem standalone kullanılabilir.
 *
 * @param {React.Node} icon         Büyük soluk ikon (opsiyonel)
 * @param {string}     message      Ana mesaj
 * @param {string}     description  Alt açıklama (opsiyonel)
 * @param {React.Node} action       Mesajın altında aksiyon (örn. "Yeni ekle" butonu)
 */
const EmptyState = ({ icon, message, description, action, sx = {} }) => (
    <Box
        sx={{
            py: 6,
            px: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            textAlign: 'center',
            ...sx,
        }}
    >
        {icon && (
            <Box sx={{ opacity: 0.2, color: 'text.secondary', display: 'flex', '& svg': { fontSize: 48 } }}>
                {icon}
            </Box>
        )}
        <Typography color="text.secondary" sx={{ fontWeight: 500 }}>
            {message}
        </Typography>
        {description && (
            <Typography variant="body2" color="text.secondary">
                {description}
            </Typography>
        )}
        {action && <Box sx={{ mt: 1 }}>{action}</Box>}
    </Box>
);

export default EmptyState;
